import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AUTH_ME_ENDPOINT } from '../config/api';

const AuthContext = createContext({
    user: null,
    loading: true,
    refreshUser: () => {},
    logout: () => {}
});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(getStoredUser());
    const [loading, setLoading] = useState(true);

    function getStoredUser() {
        try {
            const stored = localStorage.getItem('authUser');
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            return null;
        }
    }

    const refreshUser = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setUser(null);
                setLoading(false);
                return;
            }

            const response = await fetch(AUTH_ME_ENDPOINT, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Session expired');
            }

            const payload = await response.json();
            if (payload && payload.user) {
                localStorage.setItem('authUser', JSON.stringify(payload.user));
                setUser(payload.user);
            } else {
                setUser(null);
            }
        } catch (error) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('authUser');
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        setUser(null);
    };

    useEffect(() => {
        refreshUser();
    }, []);

    const value = useMemo(() => ({ user, loading, refreshUser, logout }), [user, loading]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
